import { z } from 'zod';

import { JsonSchema } from '../common';

export enum PromptAuthor {
  USER = 'user',
  BOT = 'bot',
  SYSTEM = 'system',
}

export const TextPromptSchema = z.object({ text: z.string() });
export type TextPrompt = z.infer<typeof TextPromptSchema>;
export const TextPromptWithIdSchema = TextPromptSchema.extend({ id: z.string() });

export const TextRequestSchema = z.object({ text: z.string() });
// The extra `response` here is a limitation of NestJS,  data must be an object
export const TextResponseSchema = z.object({ data: z.object({ response: JsonSchema }) });

export const ChatPromptSchema = z.object({ author: z.nativeEnum(PromptAuthor), text: z.string() });
export type ChatPrompt = z.infer<typeof ChatPromptSchema>;
export const ChatPromptWithIdSchema = ChatPromptSchema.extend({ id: z.string() });

export const ChatRequestSchema = z.object({ prompt: ChatPromptSchema, context: z.array(ChatPromptSchema).optional() });
// The extra `response` here is a limitation of NestJS,  data must be an object
export const ChatResponseSchema = z.object({ data: z.object({ response: JsonSchema }) });
